import { render } from "./statsFour.vue?vue&type=template&id=f82da008"
import script from "./statsFour.vue?vue&type=script&lang=js"
export * from "./statsFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__